<template>
    <div class="dealer-widget">
        <div class="dealer-content">
            <div class="inner-wrapper" v-if="!propertyDetails.agency">
                <div class="clear">
                    <div class="col-xs-4 col-sm-4 dealer-face">
                        <a href="#">
                            <i class="fa fa-user"></i>
                        </a>
                    </div>
                    <div class="col-xs-8 col-sm-8 ">
                        <h3 class="dealer-name">
                            <a href="#">{{propertyDetails.user.name}}</a><br/>
                            <span>Real Estate Agent</span>
                        </h3>
                    </div>
                </div>
                <div class="clear">
                    <ul class="dealer-contacts">
                        <li><i class="pe-7s-mail strong"> </i> {{propertyDetails.user.email}}</li>
                        <li v-if="propertyDetails.user.phone"><i class="pe-7s-call strong"> </i> {{propertyDetails.user.phone}}</li>
                    </ul>
                </div>
            </div>
            <div class="inner-wrapper" v-if="propertyDetails.agency">

                <div class="clear">
                    <div class="col-xs-4 col-sm-4 dealer-face">
                        <a href="#" v-if="propertyDetails.agency.picture_url">
                            <img :src="propertyDetails.agency.picture_url" class="img-circle">
                        </a>
                        <a href="#" v-else>
                            <i class="fa fa-user"></i>
                        </a>
                    </div>
                    <div class="col-xs-8 col-sm-8 ">
                        <h3 class="dealer-name">
                            <router-link :to="getAgencyDetailUrl()">{{propertyDetails.agency.name}}</router-link><br/>
                            <span>Real Estate Agent</span>
                        </h3>
                        <div class="dealer-social-media">
                            <a class="twitter" target="_blank" :href="propertyDetails.agency.twitter" v-if="propertyDetails.agency.twitter">
                                <i class="fa fa-twitter"></i>
                            </a>
                            <a class="facebook" target="_blank" :href="propertyDetails.agency.facebook" v-if="propertyDetails.agency.facebook">
                                <i class="fa fa-facebook"></i>
                            </a>
                            <a class="gplus" target="_blank" :href="propertyDetails.agency.google" v-if="propertyDetails.agency.google">
                                <i class="fa fa-google-plus"></i>
                            </a>
                            <a class="linkedin" target="_blank" :href="propertyDetails.agency.website" v-if="propertyDetails.agency.website">
                                <i class="fa fa-globe"></i>
                            </a>
                        </div>

                    </div>
                </div>

                <div class="clear">
                    <ul class="dealer-contacts">
                        <li v-if="propertyDetails.agency.address"><i class="pe-7s-map-marker strong"> </i> {{propertyDetails.agency.address}}</li>
                        <li v-if="propertyDetails.agency.email"><i class="pe-7s-mail strong"> </i> {{propertyDetails.agency.email}}</li>
                        <li v-if="propertyDetails.agency.phone"><i class="pe-7s-call strong"> </i> {{propertyDetails.agency.phone}}</li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {slugify} from "../../api/helpers";

export default {
    name: "PropertyAgencyInfo",
    props: ["propertyDetails"],
    setup(props) {

        const getAgencyDetailUrl= function () {
            return `/agency/${props.propertyDetails.agency.id}/${slugify(props.propertyDetails.agency.name)}`;
        }

        return {
            getAgencyDetailUrl
        }
    }
}
</script>

<style scoped>
    .dealer-face .fa-user {
        font-size: 96px;
        color: #fff;
    }

    .dealer-social-media .fa {
        color: #fff;
    }
</style>
